import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FilterNavigation from '../../../../molecules/filter-navigation/FilterNavigation.jsx';
import Accordion from './FaqAccordion.jsx';

const FaqSection = ({ data }) => {
  const { questions, filterNavigation } = data;
  const [activeFilter, setActiveFilter] = useState([]);

  return (
    <div className="o-faq-section__wrapper">
      <div className=" l-container l-container--has-margin l-container--column">
        <div className="l-container__wrapper">
          <div className="l-container__grid">
            {filterNavigation && (
              <FilterNavigation
                {...filterNavigation}
                setActiveFilter={setActiveFilter}
                activeFilter={activeFilter}
                hasFilterToggle={filterNavigation.filters.length > 0}
              />
            )}
            <div className="o-faq-section__questions">
              <Accordion sections={questions} activeFilter={activeFilter} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

FaqSection.propTypes = {
  data: PropTypes.shape().isRequired
};

export default FaqSection;
